import { AbstractControl, ValidatorFn } from "@angular/forms";
import moment from "moment";

export function dateFormatValidator(): ValidatorFn {
  return (control: AbstractControl): Record<string, boolean> | null => {
    let formatTest = true;
    const date = control.value;

    // catches two date values that "Invalid date" doesn't catch
    // - year length is over 9999
    // - year length is less than 1000
    if (date) {
      if (date.length > 10 || date.charAt(0) == 0) {
        formatTest = false;
      }
    }

    if (control.value === "Invalid date" || !formatTest) {
      return { "date format": true };
    }

    return null;
  };
}
export function dateValidator(): ValidatorFn {
  return (AC: AbstractControl) => {
    if (AC && AC.value && !moment(AC.value, "YYYY-MM-DD", true).isValid()) {
      return { dateValidator: true };
    }
    return null;
  };
}
